import classNames from 'classnames'
import * as React from 'react'
import reactToString from 'react-to-string'
import {MARK_LINK, NODE_HEADING, NODE_IMAGE, render} from 'storyblok-rich-text-react-renderer'

import {utils} from '@/common/config'
import {isEmptyRichtext} from '@/common/utils'
import Button from '@/components/Button'
import Iframe from '@/components/Iframe'
import Image from '@/components/Image'
import Link from '@/components/Link'
import MatomoCookiesOutput from '@/components/RichText/MatomoOptOut'
import RichTextForm from '@/components/RichText/RichTextForm'

import KeyFigures from './KeyFigures'
import Quote from './Quote'

const RichText = ({richtext, className, title}) => {
  if (isEmptyRichtext(richtext)) return null

  return (
    <div
      className={classNames(
        'prose-h2:heading-xs-millik prose-li:body-m-regular prose-p:body-m-regular [&>b]:prose-p:body-m-bold prose-a:body-m-bold prose max-w-none prose-a:text-violet-600 prose-a:no-underline prose-img:rounded-2xl',
        className
      )}
    >
      {render(richtext, {
        nodeResolvers: {
          [NODE_HEADING]: (children, props) =>
            React.createElement(
              `h${props.level}`,
              {id: utils.toKebabCase(reactToString(children))},
              children
            ),
          [NODE_IMAGE]: (_, props) => <Image {...props} />,
        },
        markResolvers: {
          [MARK_LINK]: (children, {linktype, href, anchor, target}) => {
            const link =
              linktype === 'story'
                ? {linktype, cached_url: href.replace('/', ''), anchor, target}
                : {linktype, url: href, target}

            return <Link link={link}>{children}</Link>
          },
        },
        defaultBlokResolver: (name, props) => {
          switch (name) {
            case 'rich-text-key-figures':
              return <KeyFigures {...props} />
            case 'rich-text-video':
              return <Iframe {...props} />
            case 'rich-text-matomo-opt-out':
              return <MatomoCookiesOutput />
            case 'button-primary':
              return <Button {...props} />
            case 'button-secondary':
              return <Button theme='secondary' {...props} />
            case 'quote':
              return <Quote {...props} />
            case 'rich-text-form':
              return <RichTextForm {...props} title={title} />
            default:
              return null
          }
        },
      })}
    </div>
  )
}

export default RichText
